<template>
  <div class="middle-bottom">
    <div class="mhead">
      <div class="item" @click="on_change(3)" :class="active == 3 ? 'active' : ''">日日走</div>
      <div class="item" @click="on_change(2)" :class="active == 2 ? 'active' : ''">周周练</div>
      <div class="item" @click="on_change(1)" :class="active == 1 ? 'active' : ''">月月访</div>
    </div>
    <div class="table" v-if="active == 1">
      <div class="thead">
        <div class="i-item rank">排名</div>
        <div class="i-item name">用户</div>
        <div class="i-item kcal">打卡次数</div>
      </div>
      <div class="tbody" :class="count <= 5 ? 'high' : ''">
        <transition-group name="list" tag="div">
          <div class="item" v-for="(item, i) in y_list" :key="item.name">
            <div class="i-item rank">{{ i + 1 + y_step * page_size }}</div>
            <div class="i-item name">{{ item.name }}</div>
            <div class="i-item kcal">{{ item.people_num }}</div>
          </div>
        </transition-group>
      </div>
    </div>
    <div class="table" v-if="active == 2">
      <div class="thead">
        <div class="i-item rank">排名</div>
        <div class="i-item name">用户</div>
        <div class="i-item kcal">打卡次数</div>
      </div>
      <div class="tbody" :class="count <= 5 ? 'high' : ''">
        <transition-group name="list" tag="div">
          <div class="item" v-for="(item, i) in c_list" :key="item.name">
            <div class="i-item rank">{{ i + 1 + c_step * page_size }}</div>
            <div class="i-item name">{{ item.name }}</div>
            <div class="i-item kcal">{{ item.people_num }}</div>
          </div>
        </transition-group>
      </div>
    </div>
    <div class="table" v-if="active == 3">
      <div class="thead">
        <div class="i-item rank">排名</div>
        <div class="i-item name">用户</div>
        <div class="i-item kcal">打卡次数</div>
      </div>
      <div class="tbody" :class="count <= 5 ? 'high' : ''">
        <transition-group name="list" tag="div">
          <div class="item" v-for="(item, i) in p_list" :key="item.name">
            <div class="i-item rank">{{ i + 1 + p_step * page_size }}</div>
            <div class="i-item name">{{ item.name }}</div>
            <div class="i-item kcal">{{ item.people_num }}</div>
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
let mtimer = null
let ltimer = null

export default {
  props: {
    count: {
      default: 10,
    },
    list1: {
      default() {
        return []
      },
    },
    list2: {
      default() {
        return []
      },
    },
    list3: {
      default() {
        return []
      },
    },
  },
  data() {
    return {
      page_size: 5,

      active: 3,
      list: [],

      p_step: 0,
      c_step: 0,
      y_step: 0,

      p_list: [],
      pList: [],

      c_list: [],
      cList: [],

      y_list: [],
      yList: [],
    }
  },
  mounted() {
    if (this.count <= 5) {
      this.page_size = 10
    }

    mtimer = setInterval(() => {
      if (this.active == 1) {
        this.on_change(2)
      } else if (this.active == 2) {
        this.on_change(3)
      } else {
        this.on_change(1)
      }
    }, 20000)

    this.p_step = 0
    this.pList = this.list1
    this.$set(this, 'p_list', this.list1.slice(0, this.page_size))

    this.c_step = 0
    this.cList = this.list2
    this.$set(this, 'c_list', this.list2.slice(0, this.page_size))

    this.y_step = 0
    this.yList = this.list3
    this.$set(this, 'c_list', this.list3.slice(0, this.page_size))

    ltimer = setInterval(() => {
      this.p_list = []
      this.c_list = []
      this.y_list = []

      setTimeout(() => {
        let p_step = this.p_step + 1

        // console.log(p_step, Math.floor(this.pList.length / this.page_size))

        if (p_step > Math.ceil(this.pList.length / this.page_size) - 1) {
          p_step = 0
        }

        this.p_list = this.pList.slice(this.page_size * p_step, this.page_size * p_step + this.page_size)

        this.p_step = p_step

        let c_step = this.c_step + 1

        if (c_step > Math.ceil(this.cList.length / this.page_size) - 1) {
          c_step = 0
        }

        this.c_list = this.cList.slice(this.page_size * c_step, this.page_size * c_step + this.page_size)

        this.c_step = c_step

        let y_step = this.c_step + 1

        if (y_step > Math.ceil(this.yList.length / this.page_size) - 1) {
          y_step = 0
        }

        this.y_list = this.cList.slice(this.page_size * y_step, this.page_size * y_step + this.page_size)

        this.y_step = y_step
      }, 600)
    }, this.page_size * 2000)
  },
  beforeDestroy() {
    clearInterval(mtimer)
  },
  methods: {
    on_change(i) {
      this.active = i
    },
  },
}
</script>

<style scoped>
.list-enter-active {
  transition: all 1s;
  transform-origin: top;
}

.list-leave-active {
  transition: all 0.4s;
  transform-origin: bottom;
}

.list-enter {
  opacity: 0;
  transform: rotateX(90deg);
}

.list-leave-to {
  opacity: 0;
  transform: rotateX(90deg);
}
</style>

<style lang="less" scoped>
.middle-bottom {
  // padding: 0 20px;
  .mhead {
    margin-top: -60px;
    padding: 13px 24px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .item {
      font-size: 18px;
      color: #97b4ff;
      opacity: 0.33;
      &.active {
        opacity: 1;
      }
      & + .item {
        margin-left: 8px;
      }
    }
  }
  .table {
    margin: 20px 24px 0;
    .thead {
      display: flex;
      align-items: center;
      background: rgba(68, 96, 218, 0.2);
    }
    .tbody {
      height: 200px;
      overflow: auto;
      &.high {
        height: 452px;
      }
      .item {
        width: 100%;
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(68, 96, 218, 0.2);
        .i-item {
          font-size: 16px;
          font-weight: normal;
          padding: 6px 0;
          color: #82a9ef;
        }
      }
    }
    .i-item {
      font-size: 16px;
      font-weight: 500;
      color: #00fbff;
      padding: 6px 0;
      &.rank {
        text-align: center;
        width: 15%;
      }
      &.name {
        width: 45%;
        display: flex;
        align-items: center;
        overflow: hidden; /* 超出部分隐藏 */
        white-space: nowrap; /* 文本不换行 */
        text-overflow: ellipsis; /* 省略的文本用省略号表示 */
        .avatar {
          width: 22px;
          height: 22px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 4px;
        }
      }
      // &.percent {
      //   text-align: center;
      //   width: 20%;
      // }
      &.kcal {
        text-align: center;
        width: 40%;
      }
    }
  }
}
</style>
